<script setup>
// A "scan to join" code: the QR on a white tile (phones read dark on light in
// either theme), what it joins, and the address for anyone without a camera.
// The SVG is drawn by our API from the join link's address.
defineProps({
  code: {type: Object, required: true},
  title: {type: String, required: true},
  size: {type: Number, default: 132},
});
</script>

<template>
  <div class="tv-join">
    <div class="tv-join-text">
      <span class="tv-join-title">{{ title }}</span>
      <span class="tv-join-note">
        {{ code.membersOnly ? 'For club members. ' : '' }}{{ code.needsApproval ? 'An admin confirms your place.' : 'Scan with your phone camera.' }}
      </span>
      <span class="tv-join-url">{{ code.displayUrl }}</span>
    </div>
    <div class="tv-join-qr" :style="{width: size + 'px', height: size + 'px'}" v-html="code.svg"/>
  </div>
</template>

<style scoped lang="scss">
.tv-join {
  display: flex;
  align-items: center;
  gap: 24px;
}

.tv-join-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tv-join-title {
  font-family: var(--tv-display);
  font-weight: 800;
  font-size: 32px;
  line-height: 1.2;
  color: var(--tv-ink);
}

.tv-join-note {
  font-size: 20px;
  color: var(--tv-muted);
}

.tv-join-url {
  font-size: 20px;
  font-weight: 600;
  color: var(--tv-accent-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tv-join-qr {
  flex-shrink: 0;
  padding: 6px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: content-box;

  :deep(svg) {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
